var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 5.15625L27.5 9.45312H34.375L22.3438 18.9062L25.7812 12.8906H20.625L26.6406 5.15625H30.9375Z",
    fill: "#DBDB53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 18.9062V15.4688H48.125V18.9062",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 15.4688H45.5469V18.9062H41.25V15.4688Z",
    fill: "#1D1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 18.9062V15.4688H13.75V18.9062",
    fill: "#1D1D1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 15.4688H11.1719V18.9062H6.875V15.4688Z",
    fill: "#1D1D1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5312 22.3438V18.9062H49.8438V22.3438",
    fill: "#1D1D1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5312 18.9062H47.2656V22.3438H39.5312V18.9062Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 22.3438V18.9062H15.4688V22.3438",
    fill: "#1D1D1D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 18.9062H12.8906V22.3438H5.15625V18.9062Z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 27.5H51.5625V48.125H3.4375V27.5Z",
    fill: "#1D1D1D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 27.5H48.9844V48.125H3.4375V27.5Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 36.0938H44.6875V39.5312H34.375V36.0938Z",
    fill: "#07359B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 36.0938H17.1875V32.6562H13.75V36.0938H10.3125V39.5312H13.75V42.9688H17.1875V39.5312H20.625V36.0938Z",
    fill: "#07359B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71875 48.125H53.2812V53.2812H1.71875V48.125Z",
    fill: "#07359B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71875 48.125H50.7031V53.2812H1.71875V48.125Z",
    fill: "#07359B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71875 22.3438H53.2812V27.5H1.71875V22.3438Z",
    fill: "#07359B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71875 22.3438H50.7031V27.5H1.71875V22.3438Z",
    fill: "#07359B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2812 54.1406H1.71875C1.24352 54.1406 0.859375 53.7565 0.859375 53.2812V48.125C0.859375 47.6498 1.24352 47.2656 1.71875 47.2656H53.2812C53.7565 47.2656 54.1406 47.6498 54.1406 48.125V53.2812C54.1406 53.7565 53.7565 54.1406 53.2812 54.1406ZM2.57812 52.4219H52.4219V48.9844H2.57812V52.4219Z",
    fill: "#1D1D1D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2812 28.3594H1.71875C1.24352 28.3594 0.859375 27.9744 0.859375 27.5V22.3438C0.859375 21.8694 1.24352 21.4844 1.71875 21.4844H53.2812C53.7565 21.4844 54.1406 21.8694 54.1406 22.3438V27.5C54.1406 27.9744 53.7565 28.3594 53.2812 28.3594ZM2.57812 26.6406H52.4219V23.2031H2.57812V26.6406Z",
    fill: "#1D1D1D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3281 22.3438H14.6094V19.7656H6.01562V22.3438H4.29688V18.9062C4.29688 18.4319 4.68102 18.0469 5.15625 18.0469H15.4688C15.944 18.0469 16.3281 18.4319 16.3281 18.9062V22.3438Z",
    fill: "#1D1D1D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7031 22.3438H48.9844V19.7656H40.3906V22.3438H38.6719V18.9062C38.6719 18.4319 39.056 18.0469 39.5312 18.0469H49.8438C50.319 18.0469 50.7031 18.4319 50.7031 18.9062V22.3438Z",
    fill: "#1D1D1D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 43.8281H13.75C13.2748 43.8281 12.8906 43.444 12.8906 42.9688V40.3906H10.3125C9.83727 40.3906 9.45312 40.0065 9.45312 39.5312V36.0938C9.45312 35.6185 9.83727 35.2344 10.3125 35.2344H12.8906V32.6562C12.8906 32.181 13.2748 31.7969 13.75 31.7969H17.1875C17.6627 31.7969 18.0469 32.181 18.0469 32.6562V35.2344H20.625C21.1002 35.2344 21.4844 35.6185 21.4844 36.0938V39.5312C21.4844 40.0065 21.1002 40.3906 20.625 40.3906H18.0469V42.9688C18.0469 43.444 17.6627 43.8281 17.1875 43.8281ZM14.6094 42.1094H16.3281V39.5312C16.3281 39.056 16.7123 38.6719 17.1875 38.6719H19.7656V36.9531H17.1875C16.7123 36.9531 16.3281 36.569 16.3281 36.0938V33.5156H14.6094V36.0938C14.6094 36.569 14.2252 36.9531 13.75 36.9531H11.1719V38.6719H13.75C14.2252 38.6719 14.6094 39.056 14.6094 39.5312V42.1094Z",
    fill: "#1D1D1D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6875 40.3906H34.375C33.8998 40.3906 33.5156 40.0065 33.5156 39.5312V36.0938C33.5156 35.6185 33.8998 35.2344 34.375 35.2344H44.6875C45.1627 35.2344 45.5469 35.6185 45.5469 36.0938V39.5312C45.5469 40.0065 45.1627 40.3906 44.6875 40.3906ZM35.2344 38.6719H43.8281V36.9531H35.2344V38.6719Z",
    fill: "#1D1D1D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6406 27.5H28.3594V48.125H26.6406V27.5Z",
    fill: "#1D1D1D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6094 18.9062H12.8906V16.3281H7.73438V18.9062H6.01562V15.4688C6.01562 14.9944 6.39977 14.6094 6.875 14.6094H13.75C14.2252 14.6094 14.6094 14.9944 14.6094 15.4688V18.9062Z",
    fill: "#1D1D1D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9844 18.9062H47.2656V16.3281H42.1094V18.9062H40.3906V15.4688C40.3906 14.9944 40.7748 14.6094 41.25 14.6094H48.125C48.6002 14.6094 48.9844 14.9944 48.9844 15.4688V18.9062Z",
    fill: "#1D1D1D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5469 15.4688H43.8281V5.15625C43.8281 3.73484 42.6714 2.57812 41.25 2.57812H13.75C12.3286 2.57812 11.1719 3.73484 11.1719 5.15625V15.4688H9.45312V5.15625C9.45312 2.78695 11.3807 0.859375 13.75 0.859375H41.25C43.6193 0.859375 45.5469 2.78695 45.5469 5.15625V15.4688Z",
    fill: "#1D1D1D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3438 19.7656C22.1435 19.7656 21.9433 19.6952 21.7826 19.5568C21.4715 19.2887 21.3942 18.8375 21.5978 18.48L24.2997 13.75H20.625C20.2967 13.75 19.9977 13.5627 19.8533 13.2679C19.7089 12.9731 19.7459 12.6216 19.947 12.363L25.9626 4.62859C26.125 4.41977 26.3751 4.29688 26.6406 4.29688H30.9375C31.2684 4.29688 31.5683 4.48594 31.7118 4.78414C31.8545 5.08148 31.8149 5.43555 31.6087 5.69336L29.2884 8.59375H34.375C34.742 8.59375 35.0677 8.82578 35.1871 9.17211C35.3066 9.51844 35.194 9.90258 34.9061 10.1286L22.8749 19.5817C22.7193 19.7046 22.5311 19.7656 22.3438 19.7656ZM22.3824 12.0312H25.7813C26.0872 12.0312 26.3708 12.1945 26.5246 12.4592C26.6784 12.7239 26.6793 13.0505 26.5272 13.3169L25.2734 15.5117L31.8897 10.3125H27.5C27.1692 10.3125 26.8692 10.1234 26.7257 9.82523C26.5831 9.52789 26.6226 9.17383 26.8288 8.91602L29.1491 6.01562H27.0609L22.3824 12.0312Z",
    fill: "#1D1D1D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7031 27.5H52.4219V48.125H50.7031V27.5Z",
    fill: "#1D1D1D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.57812 27.5H4.29688V48.125H2.57812V27.5Z",
    fill: "#1D1D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.bd6da1aa.svg";
export { ForwardRef as ReactComponent };